import SectionHeader from "./SectionHeader";
import Reveal from "./Reveal";
import BookingForm from "./BookingForm";

export default function Booking() {
  return (
    <section id="booking" className="border-b border-border bg-primary px-5 py-24 text-white lg:px-8 lg:py-32">
      <div className="mx-auto grid max-w-7xl items-start gap-14 lg:grid-cols-2">
        <div className="lg:sticky lg:top-28">
          <SectionHeader dark kicker="Booking" title="READY TO TREAT THE PROBLEM?" subtitle="Tell us about the property. We'll contact you to confirm availability and treatment requirements." />
          <div className="mt-10 space-y-4 rounded-lg border border-white/10 bg-white/[0.03] p-6">
            <p className="font-heading text-sm font-bold uppercase tracking-[0.16em] text-white">The process</p>
            <ol className="space-y-2.5 text-sm text-white/70">
              <li><span className="tnum text-white/70">01</span> &nbsp; Book — share property details</li>
              <li><span className="tnum text-white/70">02</span> &nbsp; Prepare — follow the instructions we send</li>
              <li><span className="tnum text-white/70">03</span> &nbsp; Treat — technician performs the treatment</li>
              <li><span className="tnum text-white/70">04</span> &nbsp; Aftercare — follow post-treatment instructions</li>
              <li><span className="tnum text-white/70">05</span> &nbsp; Follow-up — where applicable</li>
            </ol>
          </div>
        </div>
        <Reveal delay={0.1}>
          <BookingForm />
          <p className="mt-4 text-center text-xs text-white/70">We'll contact you to confirm availability and treatment requirements.</p>
        </Reveal>
      </div>
    </section>
  );
}